import { styled } from '@mui/system';
import { Typography, Skeleton } from '@mui/material';

export const PaymentOptionSubSection = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

const OptionDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'quoteLoading',
})<{ quoteLoading?: boolean }>(({ quoteLoading }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '16px 8px 16px 16px',
  cursor: quoteLoading ? 'default' : 'pointer !important',
  opacity: quoteLoading ? 0.5 : 1,
}));

export const OptionLeftContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
});
export const OptionRightContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '4px',
});
export const NewTagContainer = styled('div')({
  backgroundColor: '#73A9FF',
  color: 'white',
  borderRadius: '12px',
  padding: '0 8px',
  fontSize: '12px',
});

const RadioInput = styled('input')({
  cursor: 'pointer',
  WebkitAppearance: 'none',
  width: '20px',
  height: '20px',
  borderRadius: '50%',
  outline: 'none',
  border: '2px solid #0277BD',
  ':before': {
    content: '""',
    display: 'block',
    width: '60%',
    height: '60%',
    margin: '20% auto',
    borderRadius: '50%',
  },
  ':checked:before': {
    backgroundColor: '#0277BD',
  },
});

const RadioInputSkeleton = styled(Skeleton)({
  width: '20px',
  height: '30px',
});

const TextDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

const OptionTitleText = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: '500',
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  color: '#414046',
});

const InstallmentsText = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: '300',
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  color: '#919191',
  '> span': {
    marginLeft: '5px',
    color: '#414046',
    fontWeight: '500',
  },
});

const SkeletonOptionTitleText = styled(Skeleton)({
  width: '120px',
  height: '20px',
});

interface OptionDescriptionTextProps {
  light?: boolean;
}
const OptionDescriptionText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'light',
})<OptionDescriptionTextProps>(({ light }) => ({
  fontFamily: 'Poppins',
  fontWeight: light ? '300' : '500',
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  color: '#919191',
}));

const SkeletonOptionDescriptionText = styled(Skeleton)({
  width: '80px',
  height: '20px',
});

const AddOptionText = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: '500',
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '0.16px',
  color: '#0A7ABE',
  marginLeft: '27px',
});

const ErrorTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '16px',
  letterSpacing: '0.15px',
  color: '#D32F2F',
  marginTop: '6px',
  marginBottom: '6px',
});

const CardIconContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '35px',
  height: '35px',
  borderRadius: '50%',
  backgroundColor: '#EAEAEA',
});

const ArrowIconContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '35px',
  height: '35px',
});

const NewCardLoaderContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#FFFFFF',
  justifyContent: 'center',
  marginRight: '5px',
  borderRadius: '10px',
  zIndex: 1,
});

export {
  OptionDiv,
  RadioInput,
  TextDiv,
  OptionTitleText,
  OptionDescriptionText,
  AddOptionText,
  RadioInputSkeleton,
  SkeletonOptionTitleText,
  SkeletonOptionDescriptionText,
  ErrorTypography,
  CardIconContainer,
  ArrowIconContainer,
  InstallmentsText,
  NewCardLoaderContainer,
};
